import axios from 'axios';
import type {
  WishlistCreateRequest,
  WishlistCreateResponse,
  FeedbackCreateRequest,
  FeedbackCreateResponse,
} from '@/types/feedback';

/**
 * 提交心愿单
 */
export const createWishlistApi = (data: WishlistCreateRequest) => {
  return axios.post<WishlistCreateResponse>(
    '/api/console/work-order/v1/wishlist/create',
    data
  );
};

/**
 * 提交问题反馈
 */
export const createFeedbackApi = (data: FeedbackCreateRequest) => {
  return axios.post<FeedbackCreateResponse>(
    '/api/console/work-order/v1/feedback/create',
    data
  );
};
